import { List } from "lucide-react";
import { useEffect } from "react";
import { useCrefazContext } from "@/app/contexts/CrefazContext";
import { Button } from "../../../../../../components/ui/button";
import { TransactionsDetailsInfo } from "./components/TransactionsDetailsInfo";
import { TransactionDetailsCard } from "./components/TransactionDetailsCard";
import { useTransactionDetails } from "./useTransactionDetails";
import { Spinner } from "../../../../../../components/ui/spinner";
import { ModalRefuseTransaction } from "./components/RefuseTransactionModal";
import { ModalApproveTransaction } from "./components/ApproveTransactionModal";
import { ModalUploadFiles } from "../../../Simulations/Crefaz/components/UploadFilesModal";
import { ModalSimulatePan } from "./components/SimulatePanModal";

type TransactionDetailsProps = {
  isClient?: boolean;
};

const TransactionDetails = ({ isClient = false }: TransactionDetailsProps) => {
  const {
      data,
      isFetching,
      isLoading,
      handleGoToSellerPage,
      handleGoToCustomerPage,
    } = useTransactionDetails();
  
    const { setCustomerData, setTransactionId, setProposalData } = useCrefazContext();
  
    useEffect(() => {
      if (data) {
        setTransactionId(data._id);
        setCustomerData({
            cpf: data.customer.cpf,
            name: data.customer.name,
            birthDate: '', 
        });
        setProposalData({ value: data.value, propostaId: String(data.contract) });
      }
    }, [data, setCustomerData, setTransactionId]);

  return (
    <div className="w-full">
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}
      {!isFetching && data && (
        <>
          <div
            onClick={() =>
              isClient
                ? handleGoToCustomerPage(data.customer._id)
                : handleGoToSellerPage(data.seller._id)
            }
            className="flex cursor-pointer justify-between rounded-lg border-[1px] border-gray01 bg-[#F0F0F0] p-5"
          >
            <TransactionDetailsCard
              seller={isClient ? data.customer.name : data.seller.name}
              photo={isClient ? "" : data.seller.profileImageUrl}
              count={data.seller.transactions_count}
              isClient={isClient}
            />
            <div className="h-fit w-fit rounded-3xl bg-[#E6F0FB] px-2 py-1">
              <p className="text-sm font-semibold text-[#1960AB]">
                {isClient ? "Cliente" : "Vendedor"}
              </p>
            </div>
          </div>

          <TransactionsDetailsInfo data={data} isClient={isClient} />

          {data.config?.canViewProof && (
            <Button
              variant="ghost"
              className="flex w-full items-center gap-2 border-[1px] border-[#DFDFE2]"
              onClick={() =>
                window.open(
                `${import.meta.env.VITE_API_FGTS_URL}/transaction/${data._id}/proof`,
              )
              }
            >
              <List />
              <p className="text-xs font-semibold">Acessar comprovante</p>
            </Button>
          )}

          {data.config?.canUploadFiles && (
            <ModalUploadFiles />
          )}

          {data.config?.canApprove && (
            <ModalApproveTransaction transactionId={data._id} />
          )}

          {data.config?.canRefuse && (
            <ModalRefuseTransaction transactionId={data._id} />
          )}

          {data.config?.canSimulate && (
            <ModalSimulatePan
              transactionId={data._id}
              customerId={data.customer._id}
            />
          )}
        </>
      )}
    </div>
  );
};

export default TransactionDetails;
